module.exports = __webpack_public_path__ + "img/icon-exit-under-other-user.c2899bf7.svg";